import useSWR from "swr";
import { defaultFetcher } from "../utils";
import type { HTTPClientV3 } from "../HTTPClientV3";
import { useApiClientContext } from "../../app/ApiClientCtx";
import { JSONAPIDocument, serializers } from "../Serializer";
import { buildUrlWithQueryParams } from "../QueryParams";

export interface Collection {
  id: number;
  name: string;
  description?: string;
  numberOfItems?: number;
  subCollections?: Omit<Collection, "subCollections">[];
}

export interface CollectionHeader {
  id: number;
  name: string;
  collections?: Collection[];
}

const base = `/items/collection_headers`;

export function getCollections(APIV3: HTTPClientV3) {
  const url = buildUrlWithQueryParams(base, {
    include: "collections.sub_collections",
    "fields[collection_header]": "name,collections",
    "fields[collection]": "name,number_of_items,description, sub_collections",
  });
  const request = () => APIV3.get<JSONAPIDocument<CollectionHeader[]>>(url);
  return {
    json: () => defaultFetcher(request, serializers.collection_header),
    fallbackKey: url,
  };
}

export function useCollections() {
  const { APIV3 } = useApiClientContext();
  const { fallbackKey, json } = getCollections(APIV3);
  const { data, isValidating } = useSWR(fallbackKey, json);
  return {
    loadingCollectionList: isValidating,
    collectionList: data,
  };
}
